import isOnScreen from "./isOnScreen";

export default (element) => {
    if (element) {
        const elementBottomPos = element.getBoundingClientRect().top;

        const onScreen = isOnScreen(element);

        if (onScreen) return true;

        if (elementBottomPos < window.pageYOffset) return true;
    }

    return false
}
